/* eslint-disable @typescript-eslint/no-explicit-any */
import React from 'react'
import JSONPretty from 'react-json-pretty'
import styled, { CSSProperties } from 'styled-components'

const View = styled(JSONPretty)`
  .__json-pretty__ {
    line-height: 1.4;
    color: rgba(0, 0, 0, 0.5);
    background: #f0f2f5;
    overflow: auto;
    font-family: monospace;
  }

  .__json-key__ {
    color: #c53b0a;
  }

  .__json-value__ {
    color: #efa700;
  }

  .__json-string__ {
    color: #0089a9;
  }

  .__json-boolean__ {
    color: #5b9e14;
  }

  .__json-pretty-error__ {
    line-height: 1.3;
    color: rgba(248, 248, 242, 1);
    background: #1e1e1e;
    overflow: auto;
  }
`

const JSONView = (props: { json: any; style?: CSSProperties }) => {
  return <View data={props.json} style={{ ...props.style }} />
}

export default JSONView
